angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateDemController',
	function(
		$rootScope, $scope, $state, $stateParams, $filter, $timeout,
		$confirm,
		InvitationListComunicateService
	) {

	$scope.id       = $stateParams.id;
	$scope.event_id = $stateParams.event_id;
	$scope.showPremio2021 = false;
	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectDem = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyDem = angular.copy($rootScope.tinymceOptionsEmailBody);

	$scope.attachmentTags = [];

	$rootScope.getInvitationList($stateParams.id);

	$rootScope.getServicesUsers();

	$rootScope.getEvent( $stateParams.event_id );

	$scope.$on( 'event_tag_loaded', function() {

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' },
			{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
			{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
			{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
			{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
			{ text: 'Nome Location', value: '{LOCATION_NAME}' },
			{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
			{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
		];

		$scope.attachmentTags = [];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g,'_');
				value = value.toUpperCase();

				tinymceValues.push( { text: tag.tag, value: '{' + value + '}' } );
			} else if ( tag.type === 'attachment' ) {
				$scope.attachmentTags.push( {
					text: tag.tag,
					value: 'tag_' + tag.id,
					state: $scope.invitationListData.dem_attachment_tags.includes( 'tag_' + tag.id )
				} );
			}
		});

		$scope.tinymceOptionsEmailSubjectDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});

			editor.addButton('sections_btn', {
				type: 'listbox',
				text: 'Placeholders Sezioni',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Pulsante Azione', value: '{{UNICA_ACTION_CTA}}' },
					// { text: 'Sezione Hospitality', value: '{{UNICA_HOSPITALITY}}' },
					// { text: 'Sezione Transfer', value: '{{UNICA_TRANSFER}}' },
					// { text: 'Sezione Dati Registrazione', value: '{{UNICA_REGISTRATION_DATA}}' }
				],
				onPostRender: function () {
				}
			});

		};


		$scope.tinymceOptionsReady = true;

	});

	$scope.$on( 'invitation_list_loaded', function() {
		$scope.showPremio2021 = [
			44, 195, 196, 197, 198, 199, 200, 201, 202, 203, 194, 204, 205, 206, 207
		].includes( $rootScope.invitationListData.event_id );

		$scope.invitationListData.dem_attachment_tags =
			$scope.invitationListData.dem_attachment_tags ? $scope.invitationListData.dem_attachment_tags.split(',') : [];

		$rootScope.getEventTags( $stateParams.event_id );
	});

	/**
	 * FUNCTIONS FOR CHECK THE FORM AND SAVE THE DEM CONFIRMATION
	 */

	$scope.checkDemForm = function()
	{
		if ( !$scope.forms.dem_form.$invalid &&
			 $rootScope.invitationListData &&
			 $rootScope.invitationListData.dem && $rootScope.invitationListData.dem.dataURL != '' ) {
			return false;
		}
		return true;
	};

	$scope.saveDem = function()
	{
		$rootScope.showLoader();

		$rootScope.invitationListData.dem = $rootScope.invitationListData.dem.dataURL;

		if ( $rootScope.invitationListData.dem_logo.dataURL ) {
			$rootScope.invitationListData.dem_logo = $rootScope.invitationListData.dem_logo.dataURL;
		} else {
			$rootScope.invitationListData.dem_logo = '';
		}

		var invitationListData = angular.copy($rootScope.invitationListData);


		invitationListData.dem_attachment_tags = [];

		angular.forEach($scope.attachmentTags, function(attachmentTag, key) {
			console.log( attachmentTag );
			if ( attachmentTag.state ) {
				invitationListData.dem_attachment_tags.push(attachmentTag.value);
			}
		});

		invitationListData.dem_attachment_tags = invitationListData.dem_attachment_tags.join(',');


		InvitationListComunicateService
			.updateDem(invitationListData)
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {

					data.dem = {
						dataURL: data.dem,
						resized: {
							dataURL: data.dem
						}
					};

					data.dem_logo = {
						dataURL: data.dem_logo,
						resized: {
							dataURL: data.dem_logo
						}
					};

					$rootScope.invitationListData = data;

					$scope.showSuccessMsg('Email Invito aggiornata con successo!', '');
				}
			});
	};





	/**
	 * FUNCTIONS FOR UPLOAD ATTACHMENTS AND IMAGES
	 */

	$scope.changeInvitationListDem = function()
	{
		$rootScope.showLoader();
		$rootScope.invitationListData.dem_changed = true;
	};

	$scope.changeInvitationListDemLogo = function()
	{
		$rootScope.showLoader();
		$rootScope.invitationListData.dem_logo_changed = true;
	};

	$scope.$watch('$root.invitationListData.dem', function()
	{
		$rootScope.hideLoader();
	});

	$scope.$watch('$root.invitationListData.dem_logo', function()
	{
		$rootScope.hideLoader();
	});




	/**
	 * FUNCTIONS FOR REMOVE IMAGES
	 */

	$scope.removeDem = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine di copertina della email di invito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			InvitationListComunicateService
				.deleteDem( $stateParams.id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						// $rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.dem = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine Email Invito eliminata con successo!', '');
					}
				});

		}, function() { });
	};

	$scope.removeDemLogo = function()
	{

		$confirm({
			title: 'Sei sicuro di voler eliminare il logo della email di invito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			InvitationListComunicateService
				.deleteDemLogo( $stateParams.id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						// $rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.dem_logo = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Logo Email Invito eliminato con successo!', '');
					}
				});

		}, function() { });
	};





	/**
	 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
	 */

	$scope.searchText = '';

	$scope.searchServiceUser = function(query)
	{
		return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
	};

	$scope.selectedServiceUser = function(service)
	{
		$scope.previewDemData.user_id = ( service ? service.id : null );
	};





	/**
	 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
	 */

	$scope.previewDemData = {
		user_id: null
	};

	$scope.checkPreviewDemForm = function()
	{
		return !$scope.previewDemData.user_id;
	};

	$scope.previewDem = function()
	{
		InvitationListComunicateService
			.previewDem( $rootScope.invitationListData.id, $scope.previewDemData.user_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Anteprima inviata con successo!', '');
				}
			});
	};

});